import useFetch from "../../hooks/useFetch";
import TeamProfile from "../team-profile/team-profile.component";
import TopographyBackground from "../topography-background/topography-background.component";
import TitleAccentLine from "../title-accent-line/title-accent-line.component";

import "./leadership-team.styles.scss";

const LeadershipTeam = (props) => {
  const url = `${props.apiUrl}?populate[LeadershipTeam][populate][0]=team_members.Profile&populate[LeadershipTeam][populate][1]=slidesPerScreen`;
  const { loading, error, data } = useFetch(url);

  if (loading) return <p>Loading ... </p>;
  if (error) {
    console.log(error);
    return (
      <section className="error">
        <p>Error ⛔.</p>
      </section>
    );
  }

  if (data.data.attributes) {
    const team = data.data.attributes.LeadershipTeam.team_members.data;
    const teamMembers = team.map((member) => (
      <TeamProfile
        key={member.id}
        name={member.attributes.Name}
        text={member.attributes.Text}
        link={member.attributes.LinkedIn}
        profile={member.attributes.Profile}
      />
    ));

    return (
      <section className="leadership-team">
        <div className="leadership-team__background">
          <TopographyBackground />
          <div className="leadership-team__container">
            <TitleAccentLine title={props.title} theme="light" />
            <div className="leadership-team__member-list">
              {teamMembers}
            </div>
          </div>
        </div>
      </section>
    );
  } else {
    return <div>Data not returned</div>;
  }
};

export default LeadershipTeam;
